import { ModalWrapper } from "@repo/ui/index.tsx";

type ViewDocumentModalProps = {
  isOpen: boolean;
  handleCloseModal: () => void;
  document: any;
  containerClass?: string;
};

const ViewDocumentModal = ({
  isOpen,
  handleCloseModal,
  document,
  containerClass,
}: ViewDocumentModalProps) => {
  if (!document) return null;

  return (
    <ModalWrapper
      isOpen={isOpen}
      handleCloseModal={handleCloseModal}
      title={document?.name || "Document View"}
      containerClass={`max-w-4xl ${containerClass || ""}`}
    >
      <div className="w-full h-[80vh] bg-gray-50 rounded-lg overflow-hidden flex items-center justify-center">
        {document.original_url.endsWith(".pdf") ? (
          <iframe
            src={document?.original_url}
            className="w-full h-full"
            title={document?.name || "Document View"}
          />
        ) : (
          <img
            src={document?.original_url}
            alt={document?.name}
            className="w-full h-full object-contain"
          />
        )}
      </div>
    </ModalWrapper>
  );
};

export default ViewDocumentModal;
